import { render, staticRenderFns } from "./BankMatchedAmountsWarning.vue?vue&type=template&id=5b61b0dc&scoped=true&"
import script from "./BankMatchedAmountsWarning.vue?vue&type=script&lang=js&"
export * from "./BankMatchedAmountsWarning.vue?vue&type=script&lang=js&"
import style0 from "./BankMatchedAmountsWarning.vue?vue&type=style&index=0&id=5b61b0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61b0dc",
  null
  
)

export default component.exports